import { fetchPartnerWorkers, putPartnerWorkers } from '@/api/admin';
import type { IAdminUserDetail, IPartnerWorker } from '@/entities/admin-user.entity';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import UserAssignmentSection, { type AssignmentItem } from './user-assignment-section';

interface PartnerWorkersSectionProps {
	user: IAdminUserDetail;
}

function toAssignmentItem(worker: IPartnerWorker): AssignmentItem {
	return {
		profileId: worker.profileId,
		nickname: worker.nickname,
		meta: `Клиентов: ${worker.clientsCount} · Онлайн: ${worker.onlineClientsCount}`,
	};
}

export default function PartnerWorkersSection({ user }: PartnerWorkersSectionProps) {
	const [workers, setWorkers] = useState<IPartnerWorker[]>([]);
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);

	const loadWorkers = useCallback(async () => {
		setLoading(true);
		try {
			const data = await fetchPartnerWorkers(user.id);
			setWorkers(data);
		} finally {
			setLoading(false);
		}
	}, [user.id]);

	useEffect(() => {
		loadWorkers();
	}, [loadWorkers]);

	async function handleSave(nextItems: AssignmentItem[]) {
		setSaving(true);
		try {
			const updated = await putPartnerWorkers(user.id, nextItems.map(item => item.profileId));
			setWorkers(updated);
			toast.success('Список воркеров обновлён');
		} finally {
			setSaving(false);
		}
	}

	return (
		<UserAssignmentSection
			title='Привязанные воркеры'
			emptyText='Нет привязанных воркеров. Партнёр видит только свои логи.'
			items={workers.map(toAssignmentItem)}
			loading={loading}
			saving={saving}
			searchRole='worker'
			onSave={handleSave}
		/>
	);
}
